import cx from 'classnames';
import CTContentTitle from './CTContentTitle';
import CTButton from '../CTButton';

type OwnProps = {
  backgroundButton?: boolean;
  bottom?: boolean;
  button?: boolean;
  buttonText?: string;
  hasMobileSubText?: boolean;
  isMobile?: boolean;
  light?: boolean;
  options: {
    heading1?: string;
    heading2?: string;
    subHeading?: string;
  };
  primaryButton?: boolean;
  secondaryButton?: boolean;
  smallest?: boolean;
  textButton?: boolean;
  top?: boolean;
  useMobileStyle?: boolean;
};

export default function CTContent({
  light = false,
  top = false,
  bottom = false,
  options: { heading1, heading2, subHeading },
  isMobile = false,
  button = false,
  textButton = false,
  smallest = false,
  backgroundButton,
  primaryButton,
  secondaryButton,
  buttonText,
  hasMobileSubText = false,
  useMobileStyle = true
}: OwnProps) {
  return (
    <div
      className={cx('ct-content', {
        top,
        bottom,
        smallest,
        mobile: isMobile && useMobileStyle
      })}
    >
      <CTContentTitle
        isMobile={isMobile && useMobileStyle}
        light={light}
        heading1={heading1}
        heading2={heading2}
      />
      <p
        className={cx('ct-content-text', {
          light,
          mobile: isMobile,
          hasMobileSubText
        })}
      >
        {subHeading}
      </p>
      {button && (
        <CTButton
          light={light}
          backgroundButton={backgroundButton}
          primaryButton={primaryButton}
          secondaryButton={secondaryButton}
          text={buttonText}
          isMobile={isMobile}
          visible={button}
          textButton={textButton}
        />
      )}
    </div>
  );
}
